import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

/**
 * LanguageSwitcher - Toggle de idioma ES/EN con alto contraste
 */
export default function LanguageSwitcher({ className = '', id = 'language-switcher-btn' }) {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState((i18n.resolvedLanguage || i18n.language || 'es').substring(0, 2));

  React.useEffect(() => {
    const handleLanguageChange = (lng) => {
      if (lng) setCurrentLang(lng.substring(0, 2));
    };
    i18n.on('languageChanged', handleLanguageChange);
    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, [i18n]);

  const toggleLanguage = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const nextLang = currentLang === 'es' ? 'en' : 'es';
    try {
      localStorage.setItem('garaoke-lang', nextLang);
    } catch (err) {}
    await i18n.changeLanguage(nextLang);
    setCurrentLang(nextLang);
  };

  return (
    <button
      className={`lang-switcher ${className}`}
      onClick={toggleLanguage}
      aria-label="Cambiar idioma / Change language"
      id={id}
      type="button"
    >
      <span className={`lang-switcher__option ${currentLang === 'es' ? 'lang-switcher__option--active' : ''}`}>
        ES
      </span>
      <span className="lang-switcher__divider">/</span>
      <span className={`lang-switcher__option ${currentLang === 'en' ? 'lang-switcher__option--active' : ''}`}>
        EN
      </span>
    </button>
  );
}
